if ( $('body').hasClass('page-template-questionnaire') ) {
  const wpLocale = $('body').attr('data-wp-locale');
  const version = $('form.eligibility').attr('data-version');


  const questionnaire = new Questionnaire(wpLocale, version);

  $(window).resize(() => {
    setFooterPosition();
  });

  $(document).ready(() => {
    $('section#start').hide();

    if (Object.keys(questionnaire.answers).length !== 0 && !getParameterByName('step') && !getParameterByName('question')) {
      //- add "flush=1" to the url at the beginning of a questionnaire to clear the answers and prevent the repeat screen from showing
      if (getParameterByName('flush') && getParameterByName('flush') == '1') {
        window.localStorage.removeItem('answers');
        replaceParamByName({ flush: undefined });
      }else{
        replaceParamByName({step: 'repeat'});
      }
    } else if (!getParameterByName('step')){
      $('section#start').show();
    }

    setFooterPosition();

    if (getParameterByName('question') !== '') {
      updateProgressBar();
    }

    questionnaire.restore();

    $('section#loading').hide();
  });

  function setFooterPosition() {
    if ($('.actions').length !== 0) {
      // Place the actions div properly on window resize
      if (window.innerWidth > 930) {
        $('.actions').css('bottom', parseInt($('footer').css('height').split('px')[0]));

        if ($('section aside').length !== 0) {
          $('section aside').css({'bottom': 'auto', 'top': 'auto'});
        }
      } else {
        if ($('section aside').length !== 0) {
          $('section aside').css('bottom', parseInt($('footer').css('height').split('px')[0]));
          $('section aside').css('max-height', 'none');
          $('section form').css('padding-bottom', '1rem');

          if ($('section aside').hasClass('expanded')) {
            toggleSchedule();
          }
        } else {
          $('.actions').css('bottom', parseInt($('footer').css('height').split('px')[0]));
        }
      }
    } else {
      $('section form').css('padding-bottom', parseInt($('footer').css('height').split('px')[0]) + 40);
    }
  }

  function updateProgressBar() {
    const questions =  questionnaire.questions;
    const answers = questionnaire.answers;
    let json = questionnaire.answers['loan-type'];

    if (json && json.value === 'acquisition' && questions.indexOf('acquired-company') === -1) {
      const i = questions.indexOf('loan-type');

      questions.splice(i + 1, 0, 'acquired-company');
    }

    const question = getParameterByName('question');
    const index = questions.indexOf(question) + 1;
    const progress = (index * 100) / (questions.length + 1);

    $('.load').css('width', `${progress}%`);
    $('span.percentage').html(`${parseInt(progress)}% `);

    questions.forEach((question) => {
      if (answers[question]) {
        let value = answers[question].label;

        $(`.value.${question} p`).html(value);
        $(`.label.${question}`).css('display', 'none');
      } else {
        $(`li.step.${question}`).toggleClass('empty');

        if (question === 'personal-info') {
          $('li.section.personal-info').css('display', 'none');
        }
      }
    });
  }

  function toggleSchedule() {
    $('section aside').toggleClass('expanded');

    if ($('section aside').hasClass('expanded')) {
      $('footer').css('display', 'none');
      $('section aside').css({
        'top': 0,
        'bottom': 0
      });
    } else {
      $('footer').css('display', 'block');
      $('section aside').css({
        'top': 'auto',
        'bottom': parseInt($('footer').css('height').split('px')[0])
      });
    }
  }

  function closeModal() {
    $('.medium-modal').css('display', 'none');
  }
}
